import React from 'react';
import Footer from '../../components/Footer';

interface RiskDisclosureProps {}

const RiskDisclosure: React.FC<RiskDisclosureProps> = () => {
  return (
    <>
      <h1 className="font-medium text-4xl md:text-[64px] text-center pb-14 pt-20">
        Risk Disclosure Statement
      </h1>
      <section className="mb-20 !mt-7 mx-auto !text-xl max-w-4xl">
        <p className="mb-3">
          PLEASE READ THIS RISK DISCLOSURE STATEMENT CAREFULLY BEFORE TRANSACTING ON THE TAPINVEST™
          WEBSITE OR TAPINVEST™ APPLICATION. THE WEBSITE IS OWNED AND OPERATED BY PURPLE PETAL
          INVEST PRIVATE LIMITED ("PPIPL"). BY ACCESSING, DOWNLOADING, AND USING OUR WEBSITE OR
          APPLICATION, THE USER AGREES TO HAVE FULLY READ AND UNDERSTOOD THE RISKS ASSOCIATED WITH
          THE TRANSACTIONS MADE ON OR THROUGH THE WEBSITE AND/OR PLATFORM. THE USER FURTHER AGREES
          TO BEAR ALL RISKS ARISING OUT OF THE TRANSACTIONS ENTERED INTO ON THE PLATFORM.
        </p>

        <p className="my-8">
          Investments are subject to market risks and inherently carry risks. The User is hereby
          advised to take note of the following general risks:
        </p>

        <ol className="list-decimal ml-6 flex flex-col gap-6 md:gap-12">
          <li>
            PPIPL is an intermediary technology platform facilitating transactions in financial
            products on its Platform (as defined in the Terms). PPIPL conducts limited,
            non-exhaustive due diligence but expressly disclaims any liability for the accuracy,
            completeness, or verification of the information related to any transaction. The parties
            to the transaction are strongly advised to conduct their own independent due diligence
            and seek expert advice, including legal, tax, and financial advice, before engaging in
            any transactions.
          </li>
          <li>
            All investments are subject to market risks, including, but not limited to, changes in
            value, price, and income. The User should be aware that past performance is not
            indicative of future performance. Additionally, the parties involved in the transaction
            may face credit risks if their operations depend on capital from clients, suppliers, or
            investors. Disruptions in these sources could adversely affect their liquidity,
            financial condition, and ability to fulfill payment obligations, including but not
            limited to lease payments, purchase price, or returning leased goods.
          </li>
          <li>
            Transactions may be subject to the risk of bankruptcy, insolvency, or similar
            proceedings. If a party to a transaction declares bankruptcy or insolvency, it may be
            unable to meet its financial obligations, which could adversely affect business
            operations and result in loss of capital.
          </li>
          <li>
            Force Majeure events, including but not limited to acts of God (e.g., natural disasters,
            pandemics, government actions, or other unforeseen events), may impact business
            operations. PPIPL disclaims liability for any failure or delay in performance due to
            such events.
          </li>
          <li>
            The Platform may contain certain inaccuracies, errors, or unauthorized information.
            PPIPL makes every effort to ensure the integrity and accuracy of the information
            presented; however, PPIPL does not guarantee the completeness, correctness, or accuracy
            of the content on the website. All information available on the Platform is provided "as
            is" without any warranties, including, but not limited to, warranties of
            merchantability, fitness for a particular purpose, or non-infringement.
          </li>
          <li>
            Products and services available on the Platform may change in price or availability at
            any time and without prior notice. Additionally, fluctuations in exchange rates may
            negatively impact the value, price, or returns of investments.
          </li>

          <li>
            The parties involved in transactions on the Platform are subject to the laws and
            regulations governing their business operations. Any changes to applicable laws or
            regulations could adversely affect business operations, financial conditions, and cash
            flows. PPIPL is not a stock exchange, a registered intermediary recognized by the
            Securities and Exchange Board of India (SEBI), nor a fundraising platform. PPIPL does
            not offer guaranteed returns on any investment, whether in high-grade or low-credit-risk
            opportunities.
          </li>

          <li>
            PPIPL does not provide business, investment, legal, or tax-related advice. The platform
            is solely an intermediary enabling Users to make their own investment decisions. PPIPL
            does not personally offer investment advice, nor does it act as an advisor. The services
            available on the Platform are intended for sophisticated investors only, and Users are
            advised to carefully review any offer documents and seek independent advice if
            necessary. Users may not recover part or all of their principal investment.
          </li>

          <li>
            To the fullest extent permissible under applicable law, PPIPL and its affiliates will
            not be liable for any direct, indirect, incidental, consequential, special, exemplary,
            punitive, or any other damages, including, without limitation, loss of profits, loss of
            data, loss of goodwill, computer failure, or business interruption, arising out of or in
            any way related to the use of the website or Platform, the information provided, or any
            products or services available on the Platform.
          </li>

          <span>
            PPIPL expressly disclaims all representations, warranties, and guarantees of any kind,
            whether express or implied, and assumes no liability in this regard, including in
            relation to any entity or individual connected to it. Nothing in these terms shall be
            construed as creating a partnership, joint venture, or agency relationship between PPIPL
            and the User unless expressly provided otherwise.
          </span>

          <li>
            Any dispute arising out of or in connection with the use of the Platform or transactions
            conducted through the Platform shall be governed by and construed in accordance with the
            laws of India. The courts in Bangalore, Karnataka, shall have exclusive jurisdiction
            over any such disputes.
          </li>

          <li>
            PPIPL or its representatives will never collect personal information over the phone.
            Users should be wary of such inquiries and report them immediately to
            support@tapinvest.in.
          </li>

          <li>
            It is hereby clarified that neither PPIPL nor TAPINVEST™ is classified as a stock
            exchange, non-banking financial institution, or any other financial intermediary under
            applicable law.
          </li>

          <li>
            If any provision of this Risk Disclosure Statement is found to be unlawful, void, or
            unenforceable, it shall be severed from the remainder of the terms, which shall remain
            in full force and effect.
          </li>

          <li>
            The User acknowledges that they have had the opportunity to seek independent legal,
            financial, and tax advice before using the Platform and that PPIPL is not liable for any
            decisions made based on the information provided on the Platform.
          </li>
        </ol>

        {/* <p className="mt-6">
            Any dispute arising out of the transactions on the Platform shall be governed by the
            laws of India, and the courts in Bangalore, Karnataka shall have the sole jurisdiction
            to adjudicate the disputes arising out of such transactions.
          </p> */}
      </section>
      <Footer />
    </>
  );
};

RiskDisclosure.displayName = 'RiskDisclosure';

export default RiskDisclosure;
